import { render, staticRenderFns } from "./Index-Dashboard.vue?vue&type=template&id=013d9cd2&scoped=true&"
import script from "./Index-Dashboard.vue?vue&type=script&lang=js&"
export * from "./Index-Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Index-Dashboard.vue?vue&type=style&index=0&id=013d9cd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013d9cd2",
  null
  
)

export default component.exports